
    <template>
      <section class="content element-doc">
        <h2 id="shu-zi-shu-ru-kuang"><a class="header-anchor" href="#shu-zi-shu-ru-kuang">¶</a> 数字输入框</h2>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/input-number">element-ui </a> <code>el-input-number</code> 组件文档</p>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;sh-input-number v-model=&quot;value1&quot; :min=&quot;1&quot; :max=&quot;10&quot; controls&gt;&lt;/sh-input-number&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        value1: 1
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="wen-zi-dui-qi"><a class="header-anchor" href="#wen-zi-dui-qi">¶</a> 文字对齐</h3>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;sh-input-number v-model=&quot;value1&quot; :min=&quot;1&quot; :max=&quot;10&quot; textAlign=&quot;center&quot;&gt;&lt;/sh-input-number&gt;

    &lt;sh-input-number v-model=&quot;value1&quot; :min=&quot;1&quot; :max=&quot;10&quot; textAlign=&quot;left&quot; style=&quot;margin-top: 16px&quot;&gt;&lt;/sh-input-number&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        value1: 1
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>controls</td>
<td>是否使用控制按钮</td>
<td>boolean</td>
<td>-</td>
<td>false</td>
</tr>
<tr>
<td>text-align</td>
<td>输入框内容对齐方式</td>
<td>string</td>
<td>left/center/right</td>
<td>right</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('sh-input-number',{attrs:{"min":1,"max":10,"controls":""},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        value1: 1
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('sh-input-number',{attrs:{"min":1,"max":10,"textAlign":"center"},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}}),_vm._v(" "),_c('sh-input-number',{staticStyle:{"margin-top":"16px"},attrs:{"min":1,"max":10,"textAlign":"left"},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        value1: 1
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  